import { render, staticRenderFns } from "./BCSwitch.vue?vue&type=template&id=bcce69b8&scoped=true"
import script from "./BCSwitch.vue?vue&type=script&lang=ts"
export * from "./BCSwitch.vue?vue&type=script&lang=ts"
import style0 from "./BCSwitch.vue?vue&type=style&index=0&id=bcce69b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcce69b8",
  null
  
)

export default component.exports